import { Injectable } from '@angular/core';
import { global } from '../../../shared/global';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class schoolfeesincrease {

    constructor(private http: HttpClient) { }
    //   getRegistrationList(data)
    //   {
    //     return this.http.post(global.baseAPIUrl + 'registration/GetRegistrationDetails', data);
    //   }
    //   deleteRegistration(data)
    //   {
    //     return this.http.post(global.baseAPIUrl + 'registration/deleteRegistration', data);
    //   }
    fillMedium(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillMedium', data, global.httpOptions);
    }
    fillStandard(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillStandardWithYearCount', data, global.httpOptions);
    }
    fillAcademicYear(data) {
        return this.http.post(global.baseAPIUrl + 'DropDown/fillAcademicYear', data, global.httpOptions);
    }
    getFeesIncreaseDetail(data) {
        return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/getFeesIncreaseDetail', data, global.httpOptions);
    }
    saveSchoolFeesIncrease(data) {
        return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/saveSchoolFeesIncrease', data, global.httpOptions);
    }
    fillSchoolFeesIncreaseDetail(data) {
        return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/fillSchoolFeesIncreaseDetail', data, global.httpOptions);
    }
    // getSchoolFeesIncreaseList(data) {
    //     return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/getSchoolFeesIncreaseList', data, global.httpOptions);
    // }
    // deleteSchoolFeesIncreaseDetail(data) {
    //     return this.http.post(global.baseAPIUrl + 'SchoolFeesIncrease/deleteSchoolFeesIncreaseDetail', data, global.httpOptions);
    // }
}